import { cloneDeep } from 'lodash';
import { elements } from '@/components/collateral/collateral-element/elements';
import EventBus from '@/scripts/event-bus';
import AppPopup from '@/components/popups/app-popup';
import CollateralBuilderVersioning from '@/mixins/collateral-builder-versioning-mixin';

export default {
    computed: {
        selectedElements() {
            return this.collateralBuild.layerContext === 'pages'
                ? this.collateralBuild.configuration.pages.reduce((acc, page) => {
                      var selectedPageElements = page.elements.filter(
                          (element) => element.selected
                      );
                      return acc.concat(selectedPageElements);
                  }, [])
                : this.collateralBuild.configuration.masterPages.reduce((acc, page) => {
                      var selectedPageElements = page.elements.filter(
                          (element) => element.selected
                      );
                      return acc.concat(selectedPageElements);
                  }, []);
        },
    },
    
    methods: {
        ...CollateralBuilderVersioning,
        setSettingsContext(key, context, isMultiSelect) {
            if(this.collateralBuild.isTransforming) {
                this.collateralBuild.isTransforming = false;
            }
            else {
                var titles = {
                    'dnd': 'Elements',
                    'default-settings': 'Default Settings',
                    'page': 'Page Settings',
                    'image': 'Image',
                    'button': 'Button',
                    'shape': 'Shape',
                    'pagination': 'Pagination',
                    'company-logo': 'Company Logo'
                };
    
                var title = titles[key];
    
                if (key === 'page') {
                    if(this.isPagesContext()) {
                        title = 'Page Settings';
                    }
                    else if(this.isMasterPagesContext()) {
                        title = 'Master Page Settings';
                    }
                }
    
                this.collateralBuild.settings = {
                    key: key,
                    title: title,
                    context: context
                };

                if(key === 'dnd' || (!isMultiSelect && !context.selected)){
                    this.unselectElements();
                }
    
                if (this.isElement(key)) {
                    this.collateralBuild.settings.context.selected = true;
                }
            }
        },

        unselectElements() {
            if(this.isPagesContext()) {
                this.collateralBuild.configuration.pages.forEach(page => {
                    this.unselectElemenstByPage(page);

                });
            }
            else if(this.isMasterPagesContext()) {
                this.collateralBuild.configuration.masterPages.forEach(page => {
                    this.unselectElemenstByPage(page);
                });
            }
        },

        unselectElemenstByPage(page) {
            page.elements.forEach((element, eIndex) => {
                element.selected = false;
                
                if(element.type === 'text') {
                    if(element.editMode) {
                        element.position.z = page.elements.length - eIndex;
                        element.editMode = false;
                        element.isFocused = false;
                    }
                }
            });
        },

        isElement(value) {
            switch(value) {
                case 'text':
                    return true;
                case 'image':
                    return true;
                case 'shape':
                    return true;
                case 'button':
                    return true;
                case 'pagination':
                    return true;
                case 'company-logo':
                    return true;
                default:
                    return false;
            }
        },

        isPagesContext() {
            return this.collateralBuild.layerContext.toUpperCase() === 'PAGES';
        },

        isMasterPagesContext() {
            return this.collateralBuild.layerContext.toUpperCase() === 'MASTERPAGES';
        },

        getPageById(id) {
            if (this.isPagesContext()) {
                return this.collateralBuild.configuration.pages.find(page => page.id === id);
            }
            else if (this.isMasterPagesContext()) {
                return this.collateralBuild.configuration.masterPages.find(page => page.id === id);
            }
        },

        getSelectedPageFromContext() {
            if(this.isPagesContext()) {
                return this.collateralBuild.configuration.pages.find(page => page.selected);
                
            }
            else if(this.isMasterPagesContext()) {
                return this.collateralBuild.configuration.masterPages.find(page => page.selected);
            }
        },

        getPagesFromContext() {
            if (this.isPagesContext()) {
                return this.collateralBuild.configuration.pages;
            }
            else if (this.isMasterPagesContext()) {
                return this.collateralBuild.configuration.masterPages;
            }
        },

        setCurrentMasterPage(page) {
            this.collateralBuild.configuration.masterPages.forEach(mp => {
                mp.selected = false;
            });

            page.selected = true;
        },

        setCurrentPageByElement(el) {
            if(this.isPagesContext()) {
                this.collateralBuild.configuration.pages.forEach((page, index) => {
                    page.selected = false;
                    
                    page.elements.forEach(element => {
                        if(element.id === el.id) {
                            page.selected = true;
                        }
                    });
                });
            }
            else if(this.isMasterPagesContext()) {
                this.collateralBuild.configuration.masterPages.forEach(page => {
                    page.selected = false;

                    page.elements.forEach(element => {
                        if(element.id === el.id) {
                            page.selected = true;
                        }
                    });
                });
            }
        },

        selectPageByPagePosition() {
            var relativeLimit = 0.15 / (this.collateralBuild.zoom / 100);

            var pages = this.getPagesFromContext();

            for (var i = pages.length - 1; i >= 0; i--) {
                var page = pages[i];
                var pagePosition = document.getElementById(`${page.id}`).getBoundingClientRect();

                var relativeTop = pagePosition.top / pagePosition.height;

                var shouldUpdatePage = relativeTop < relativeLimit
                    && relativeTop > 0
                    && this.getSelectedPageFromContext()
                    && this.getSelectedPageFromContext().id !== page.id;
                
                if (shouldUpdatePage) {
                    this.selectPage(page);
                    break;
                }
            }
        },
        
        selectPage(page) {
            this.unselectPages();
            history.pushState({}, '', `#${ page.id }`);
            page.selected = true;
        },

        initializePagesSelectedProperty() {
            if (this.collateralBuild.configuration.pages.length > 0) {
                this.collateralBuild.configuration.pages[0].selected = true;
            }

            if (this.collateralBuild.configuration.masterPages.length > 0) {
                this.collateralBuild.configuration.masterPages[0].selected = true;
            }
        },

        unselectPages() {
            this.getPagesFromContext().forEach(page => page.selected = false);
        },

        createPage(global) {
            var newPage = this.getNewPage(global);
            if(this.isPagesContext()) {
                this.collateralBuild.configuration.pages.push(newPage);
                newPage.selected = this.collateralBuild.configuration.pages.length === 1;
            }
            else if(this.isMasterPagesContext()) {
                this.collateralBuild.configuration.masterPages.push(newPage);
                newPage.selected = this.collateralBuild.configuration.masterPages.length === 1;
                newPage.name = 'Master Page ' + String.fromCharCode(this.collateralBuild.configuration.masterPages.length + 64);
            }
        },

        patchCollateralBuildConfiguration(configuration) {
            this.patchPage(configuration);
            this.patchMasterPages(configuration);
            this.patchCompanyLogo(configuration);
        },

        patchPage(configuration) {
            configuration.pages.forEach(page => {
                if(!page.hasOwnProperty('masterPage')) {
                    page.masterPage = null;
                }

                if(!page.hasOwnProperty('name')) {
                    page.name = null;
                }

                if(!page.hasOwnProperty('backgroundName')) {
                    page.backgroundName = null;
                }
            });
        },

        patchMasterPages(configuration) {
            if(!configuration.hasOwnProperty('masterPages')) {
                configuration.masterPages = [this.getNewPage(configuration.global)];
            }
        },

        patchCompanyLogo(configuration) {
            if(!configuration.global.hasOwnProperty('image')) {
                configuration.global.image = {
                    name: null,
                    src: null
                }
            }

            if(!configuration.global.hasOwnProperty('lightImage')) {
                configuration.global.lightImage = {
                    name: null,
                    src: null
                }
            }
        },

        refreshCompanyLogo(configuration, global) {
            if (global.image) {
                configuration.global.image= {
                    name: global.image.name,
                    src:  global.image.src
                }
            }

            if (global.lightImage) {
                configuration.global.lightImage= {
                    name: global.lightImage.name,
                    src:  global.lightImage.src
                }
            }
        },

        getDefaultCollateralBuildConfiguration(global) {
            var configuration = {
                layout: 'portrait',
                global: global,
                pages: [],
                masterPages: [],
            };
            configuration = this.repairMissingCollateralBuildConfigurationDefaults(configuration, global);
            return configuration;
        },

        repairMissingCollateralBuildConfigurationDefaults(configuration, global) {
            if (!configuration.layout) {
                configuration.layout = 'portrait';
            }
            if (global) {
                if (!configuration.global) {
                    configuration.global = global;
                }
                if (!configuration.pages || configuration.pages.length === 0) {
                    configuration.pages = [this.getNewPage(configuration.global)];
                }
                if (!configuration.masterPages || configuration.masterPages.length === 0) {
                    configuration.masterPages = [this.getNewPage(configuration.global)];
                    configuration.masterPages[0].name = 'Master Page A';
                }
            } else {
                if (!configuration.global) {
                    configuration.global = null;
                }
                if (!configuration.pages) {
                    configuration.pages = [];
                }
                if (!configuration.masterPages) {
                    configuration.masterPages = []
                }
            }
            return configuration;
        },

        getNewPage(global) {
            var page = {
                id: `p-${ this.$helpers.createGuid() }`,
                backgroundColor: {
                    enabled: global.background.pageBackgroundColor.enabled,
                    value: global.background.pageBackgroundColor.value,
                    type: global.background.pageBackgroundColor.type,
                    branding: global.background.pageBackgroundColor.branding
                },
                src: global.background.src,
                backgroundOffsets: {
                    top: 0,
                    left: 0
                },
                elements: [],
                selected: false,
                isCollapsed: false,
                masterPage: null,
                name: null,
                backgroundName: null
            };

            return page;
        },

        getDefaultGlobalConfiguration() {
            return {
                image: {
                    name: null,
                    src: null,
                    link: {
                        collateralId: null,
                        src: null,
                        preview: null,
                        name: null,
                        type: null,
                    }
                },
                primaryColor: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#F30070',
                },
                accentColor: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#EB7E0A',
                },
                secondaryColor: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#8274E8',
                },
                pagination: {
                    color: {
                        branding: null,
                        enabled: true,
                        type: null,
                        value: '#FFFFFF',
                    },
                    fontSize: 58.3338,
                    fontFamily: {
                        key: 'Roboto',
                        value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`
                    },
                },
                heading1: {
                    color: {
                        enabled: true,
                        value: '#f30071',
                        type: 'branded',
                        branding: '[Heading1Color]'
                    },
                    fontSize: 216.6684,
                    fontFamily: {
                        key: 'Roboto',
                        value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`
                    },
                },
                heading2: {
                    color: {
                        enabled: true,
                        value: '#EB7E0A',
                        type: 'branded',
                        branding: '[Heading2Color]'
                    },
                    fontSize: 112.5009,
                    fontFamily: {
                        key: 'Roboto',
                        value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`
                    },
                },
                heading3: {
                    color: {
                        enabled: true,
                        value: '#877D88',
                        type: 'branded',
                        branding: '[Heading3Color]'
                    },
                    fontSize: 100.0008,
                    fontFamily: {
                        key: 'Roboto',
                        value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`
                    },
                },
                heading4: {
                    color: {
                        enabled: true,
                        value: '#382153',
                        type: 'branded',
                        branding: '[Heading4Color]'
                    },
                    fontSize: 75.0006,
                    fontFamily: {
                        key: 'Roboto',
                        value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`
                    },
                },
                heading5: {
                    color: {
                        enabled: true,
                        value: '#382153',
                        type: 'branded',
                        branding: '[Heading5Color]'
                    },
                    fontSize: 75.0006,
                    fontFamily: {
                        key: 'Roboto',
                        value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`
                    },
                },
                heading6: {
                    color: {
                        enabled: true,
                        value: '#382153',
                        type: 'branded',
                        branding: '[Heading6Color]'
                    },
                    fontSize: 75.0006,
                    fontFamily: {
                        key: 'Roboto',
                        value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`
                    },
                },
                text: {
                    color: {
                        enabled: true,
                        value: '#382153',
                        type: 'branded',
                        branding: '[BodyColor]'
                    },
                    fontSize: 58.3338,
                    fontFamily: {
                        key: 'Roboto',
                        value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`
                    },
                },
                headerFooter: {
                    color: {
                        enabled: true,
                        value: '#FFFFFF',
                        type: 'branded',
                        branding: '[PaginationColor]'
                    },
                    fontSize: 83.334,
                    fontFamily: {
                        key: 'Roboto',
                        value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`
                    },
                },
                linkColor: {
                    enabled: true,
                    value: '#18AEFF',
                    type: 'branded',
                    branding: '[LinkColor]'
                },
                button: {
                    textColor: {
                        enabled: true,
                        value: '#FFFFFF',
                        type: 'branded',
                        branding: '[ButtonTextColor]'
                    },
                    buttonColor: {
                        enabled: true,
                        value: '#F30070',
                        type: 'branded',
                        branding: '[ButtonColor]'
                    },
                    borderColor: {
                        enabled: true,
                        value: '#18AEFF',
                        type: 'branded',
                        branding: '[ButtonStrokeColor]'
                    },
                    borderRadius: 'none',
                },
                background: {
                    pageBackgroundColor: {
                        enabled: true,
                        value: '#FFFFFF',
                        type: 'branded',
                        branding: '[PaperColor]'
                    },
                    src: null,
                    previewImageUrl: null,
                    name: null
                }
            };
        },

        getBrandingOptionsFromColors(configuration) {
            var options = [];

            options.push({
                name: 'Paper Color',
                key: '[PaperColor]',
                color: configuration.backgroundColor.value
            });
    
            options.push({
                name: 'Primary Color',
                key: '[PrimaryColor]',
                color: configuration.primaryColor.value
            });
    
            options.push({
                name: 'Accent Color',
                key: '[AccentColor]',
                color: configuration.accentColor.value
            });
    
            options.push({
                name: 'Secondary Color',
                key: '[SecondaryColor]',
                color: configuration.secondaryColor.value
            });
    
            options.push({
                name: 'Body Color',
                key: '[BodyColor]',
                color: configuration.text.color.value
            });
    
            options.push({
                name: 'Link Color',
                key: '[LinkColor]',
                color: configuration.linkColor.value
            });
    
            options.push({
                name: 'Pagination Color',
                key: '[PaginationColor]',
                color: configuration.pagination.color.value
            });
    
            options.push({
                name: 'Heading 1',
                key: '[Heading1Color]',
                color: configuration.heading1.color.value
            });
    
            options.push({
                name: 'Heading 2',
                key: '[Heading2Color]',
                color: configuration.heading2.color.value
            });
    
            options.push({
                name: 'Heading 3',
                key: '[Heading3Color]',
                color: configuration.heading3.color.value
            });
    
            options.push({
                name: 'Heading 4',
                key: '[Heading4Color]',
                color: configuration.heading4.color.value
            });
            
            options.push({
                name: 'Heading 5',
                key: '[Heading5Color]',
                color: configuration.heading5.color.value
            });
            
            options.push({
                name: 'Heading 6',
                key: '[Heading6Color]',
                color: configuration.heading6.color.value
            });
    
            options.push({
                name: 'Button Text Color',
                key: '[ButtonTextColor]',
                color: configuration.button.textColor.value
            });
    
            options.push({
                name: 'Button Color',
                key: '[ButtonColor]',
                color: configuration.button.backgroundColor.value
            });
    
            options.push({
                name: 'Button Stroke',
                key: '[ButtonStrokeColor]',
                color: configuration.button.borderColor.value
            });
    
            return options;
        },

        getGlobalConfigurationFromBranding(configuration) {
            return {
                image: {
                    name: configuration.image.name,
                    src: configuration.image.src,
                    link: {
                        collateralId: null,
                        src: null,
                        preview: null,
                        name: null,
                        type: null,
                    }
                },
                lightImage: {
                    name: configuration.lightImage.name,
                    src: configuration.lightImage.src,
                    link: {
                        collateralId: null,
                        src: null,
                        preview: null,
                        name: null,
                        type: null,
                    }
                },
                primaryColor: {
                    enabled: configuration.primaryColor.enabled,
                    value: configuration.primaryColor.value,
                    type: 'branded',
                    branding: '[PrimaryColor]'
                },
                accentColor: {
                    enabled: configuration.accentColor.enabled,
                    value: configuration.accentColor.value,
                    type: 'branded',
                    branding: '[AccentColor]'
                },
                secondaryColor: {
                    enabled: configuration.secondaryColor.enabled,
                    value: configuration.secondaryColor.value,
                    type: 'branded',
                    branding: '[SecondaryColor]'
                },
                heading1: {
                    color: {
                        enabled: configuration.heading1.color.enabled,
                        value: configuration.heading1.color.value,
                        type: 'branded',
                        branding: '[Heading1Color]'
                    },
                    fontSize: configuration.heading1.fontSize * this.collateralBuild.pdfScaleFactor,
                    fontFamily: {
                        key: configuration.heading1.fontFamily.key,
                        value: configuration.heading1.fontFamily.value
                    },
                },
                heading2: {
                    color: {
                        enabled: configuration.heading2.color.enabled,
                        value:  configuration.heading2.color.value,
                        type: 'branded',
                        branding: '[Heading2Color]'
                    },
                    fontSize: configuration.heading2.fontSize * this.collateralBuild.pdfScaleFactor,
                    fontFamily: {
                        key: configuration.heading2.fontFamily.key,
                        value: configuration.heading2.fontFamily.value
                    },
                },
                heading3: {
                    color: {
                        enabled: configuration.heading3.color.enabled,
                        value: configuration.heading3.color.value,
                        type: 'branded',
                        branding: '[Heading3Color]'
                    },
                    fontSize: configuration.heading3.fontSize * this.collateralBuild.pdfScaleFactor,
                    fontFamily: {
                        key: configuration.heading3.fontFamily.key,
                        value: configuration.heading3.fontFamily.value
                    },
                },
                heading4: {
                    color: {
                        enabled: configuration.heading4.color.enabled,
                        value: configuration.heading4.color.value,
                        type: 'branded',
                        branding: '[Heading4Color]'
                    },
                    fontSize: configuration.heading4.fontSize * this.collateralBuild.pdfScaleFactor,
                    fontFamily: {
                        key: configuration.heading4.fontFamily.key,
                        value: configuration.heading4.fontFamily.value
                    },
                },
                heading5: {
                    color: {
                        enabled: configuration.heading5.color.enabled,
                        value: configuration.heading5.color.value,
                        type: 'branded',
                        branding: '[Heading5Color]'
                    },
                    fontSize: configuration.heading5.fontSize * this.collateralBuild.pdfScaleFactor,
                    fontFamily: {
                        key: configuration.heading5.fontFamily.key,
                        value: configuration.heading5.fontFamily.value
                    },
                },
                heading6: {
                    color: {
                        enabled: configuration.heading6.color.enabled,
                        value: configuration.heading6.color.value,
                        type: 'branded',
                        branding: '[Heading6Color]'
                    },
                    fontSize: configuration.heading6.fontSize * this.collateralBuild.pdfScaleFactor,
                    fontFamily: {
                        key: configuration.heading6.fontFamily.key,
                        value: configuration.heading6.fontFamily.value
                    },
                },
                text: {
                    color: {
                        enabled: configuration.text.color.enabled,
                        value: configuration.text.color.value,
                        type: 'branded',
                        branding: '[BodyColor]'
                    },
                    fontSize: configuration.text.fontSize * this.collateralBuild.pdfScaleFactor,
                    fontFamily: {
                        key: configuration.text.fontFamily.key,
                        value: configuration.text.fontFamily.value
                    },
                },
                pagination: {
                    color: {
                        enabled: configuration.pagination.color.enabled,
                        value: configuration.pagination.color.value,
                        type: 'branded',
                        branding: '[PaginationColor]'
                    },
                    fontSize: configuration.pagination.fontSize * this.collateralBuild.pdfScaleFactor,
                    fontFamily: {
                        key: configuration.pagination.fontFamily.key,
                        value: configuration.pagination.fontFamily.value
                    },
                },
                linkColor: {
                    enabled: true,
                    value: configuration.linkColor.value,
                    type: 'branded',
                    branding: '[LinkColor]'
                },
                button: {
                    textColor: {
                        enabled: configuration.button.textColor.enabled,
                        value: configuration.button.textColor.value,
                        type: 'branded',
                        branding: '[ButtonTextColor]'
                    },
                    buttonColor: {
                        enabled: configuration.button.backgroundColor.enabled,
                        value: configuration.button.backgroundColor.value,
                        type: 'branded',
                        branding: '[ButtonColor]'
                    },
                    borderColor: {
                        enabled: configuration.button.borderColor.enabled,
                        value: configuration.button.borderColor.value,
                        type: 'branded',
                        branding: '[ButtonStrokeColor]'
                    },
                    borderRadius: configuration.button.borderRadius,
                },
                background: {
                    pageBackgroundColor: {
                        enabled: configuration.backgroundColor.enabled,
                        value: configuration.backgroundColor.value,
                        type: 'branded',
                        branding: '[PaperColor]'
                    },
                    src: null,
                    previewImageUrl: null,
                    name: null
                }
            };
        },

        duplicatePage(page) {
            var newPage = JSON.parse(JSON.stringify(page));
            
            newPage.selected = false;
            newPage.id = `p-${ this.$helpers.createGuid() }`;
            newPage.elements.forEach(element => {
                element.id = `e-${ this.$helpers.createGuid() }`;
                element.pageId = newPage.id;
            });

            newPage.isCollapsed = false;

            var pages = this.getPagesFromContext()
            pages.push(newPage);

            this.updateAllPagePaginationElements();
        },

        deletePage(page) {
            this.$modal.show(AppPopup, {
                type: 'alert-popup',
                title: `Are you sure?`,
                content: `<p>${page.name || 'This'} page will be permanently deleted.</p>`,
                actions: {
                    confirm: {
                        label: `Delete`,
                        action: () => {
                            var pages = this.getPagesFromContext();
                            var index = pages.indexOf(page);
                            
                            if (this.isMasterPagesContext()) {
                                this.removeMasterPageFromPage(this.collateralBuild.configuration.masterPages[index]);
                            }
                            
                            pages.splice(index, 1);
                            this.setSelectedPageAfterDeletion(index, pages);
                            this.updateAllPagePaginationElements();
                        }
                    },
                    cancel: {
                        label: 'Cancel'
                    }
                },
                args: null,
            },{
                height: this.$helpers.setPopupHeight(),
                width: this.$helpers.setPopupWidth()
            });
        },

        setSelectedPageAfterDeletion(index, pages) {
            if (pages.length > 0) {
                var isOnlyPage = pages.length === 1;
                var isFirstPage = index === 0;
                var isLastPage = index === pages.length;

                if (isOnlyPage || isFirstPage) {
                    pages[0].selected = true;
                }
                else if (isLastPage) {
                    pages[pages.length - 1].selected = true;
                }
                else {
                    pages[index].selected = true;
                }
            }
        },

        removeMasterPageFromPage(masterPage) {
            this.collateralBuild.configuration.pages.forEach(item => {
                if(item.masterPage && item.masterPage.id === masterPage.id) {
                    item.masterPage = null;
                }
            })
        },

        updatePagesWithMasterPageChanges(masterPage) {
            this.collateralBuild.configuration.pages.forEach((page, index) => {
                if (page.masterPage && page.masterPage.id === masterPage.id) {
                    page.masterPage = this.getClonedMasterPage(masterPage);
                    this.updatePaginationElementsByPage(index, page.masterPage);
                }
            });
        },

        getClonedMasterPage(masterPage) {
            var clonedMasterPage = cloneDeep(masterPage);
            this.refreshElementIds(clonedMasterPage);

            return clonedMasterPage;
        },

        refreshElementIds(page) {
            page.elements.forEach(element => element.id = `e-${this.$helpers.createGuid()}`);
        },

        updateAllPagePaginationElements() {

            this.getPagesFromContext().forEach((page, index) => {
                this.updatePaginationElementsByPage(index, page);

                if(page.masterPage) {
                    this.updatePaginationElementsByPage(index, page.masterPage);
                }
            });
        },

        updatePaginationElementsByPage(pageIndex, page) {
            var paginationElements = [];

            page.elements.forEach(element => {
                if(element.type === 'pagination') {
                    paginationElements.push(element);
                }
            });

            if(paginationElements.length > 0) {
                paginationElements.forEach(element => {
                    this.setPaginationIndex(pageIndex, element);
                });
            }
        },

        getNewElement(type, global) {
            var el;
            elements.forEach(element => {
                if(element.type.toUpperCase() === type.toUpperCase()) {
                    el = cloneDeep(element);
                    el.id = `e-${ this.$helpers.createGuid() }`
                }
            });

            this.mapGlobalConfigToElement(el, global);

            return el;
        },

        mapGlobalConfigToElement(element, global) {
            if(element.type.toUpperCase() === "BUTTON") {
                element.textColor = {
                    branding: global.button.textColor.branding,
                    enabled: global.button.textColor.enabled,
                    type: global.button.textColor.type,
                    value: global.button.textColor.value
                },

                element.buttonColor = {
                    branding: global.button.buttonColor.branding,
                    enabled: global.button.buttonColor.enabled,
                    type: global.button.buttonColor.type,
                    value: global.button.buttonColor.value
                },

                element.borderColor = {
                    branding: global.button.borderColor.branding,
                    enabled: global.button.borderColor.enabled,
                    type: global.button.borderColor.type,
                    value: global.button.borderColor.value
                },

                element.borderRadius = global.button.borderRadius
            }
        },

        deleteElement(el) {
            var selectedPage = this.getPageById(el.pageId);
            
            selectedPage.elements.forEach(element => {
                if(element.id === el.id) {
                    selectedPage.elements.splice(selectedPage.elements.indexOf(element), 1);
                    this.setElementsZPosition(selectedPage);
                    this.setSettingsContext('dnd');
                }
            });
        },

        addDuplicatedElement(element) {
            var duplicateElement = cloneDeep(element);
            duplicateElement.id = `e-${ this.$helpers.createGuid() }`;
            
            var page = this.getPageById(duplicateElement.pageId);
            page.elements.unshift(duplicateElement);
            
            this.calculateAlignment(duplicateElement, 'CENTER');
            this.calculateAlignment(duplicateElement, 'MIDDLE');
            this.initializeElementProperties(duplicateElement, page);
            this.setSettingsContext(duplicateElement.type, duplicateElement);
        },

        toggleVisibility(element) {
            element.visible = !element.visible;
        },

        closeColorPickers() {
            EventBus.$emit('close-collateral-color-pickers');
        },

        getPageHeight() {
            var height = this.collateralBuild.configuration.layout.toUpperCase() === 'PORTRAIT' ? this.getPortraitHeight() : this.getLandscapeHeight();
            return height;
        },

        getPageWidth() {
            var width = this.collateralBuild.configuration.layout.toUpperCase() === 'PORTRAIT' ? this.getPortraitWidth() : this.getLandscapeWidth();
            return width;
        },

        getPortraitHeight() {
            var custom = this.collateralBuild.options.pageSizes[0].key;
            var a4 = this.collateralBuild.options.pageSizes[1].key;
            var letter = this.collateralBuild.options.pageSizes[2].key;
            var paper5x7 = this.collateralBuild.options.pageSizes[3].key;
            var paper4x6 = this.collateralBuild.options.pageSizes[4].key; 
            
            switch(this.collateralBuild.pageSize)
            {
                case a4:
                    return 3505;
                case letter:
                    return 3300;
                case paper5x7:
                    return 2100;
                case paper4x6:
                    return 1800;
                case custom:
                    return this.generateCustomHeight(this.collateralBuild.configuration);
                default:
                    break;
            }
        },

        getLandscapeHeight() {
            var custom = this.collateralBuild.options.pageSizes[0].key;
            var a4 = this.collateralBuild.options.pageSizes[1].key;
            var letter = this.collateralBuild.options.pageSizes[2].key;
            var paper5x7 = this.collateralBuild.options.pageSizes[3].key;
            var paper4x6 = this.collateralBuild.options.pageSizes[4].key; 

            switch(this.collateralBuild.pageSize)
            {
                case a4:
                    return 2481;
                case letter:
                    return 2550;
                case paper5x7:
                    return 1500;
                case paper4x6:
                    return 1200;
                case custom:
                    // Landscape flips width and height
                    return this.generateCustomWidth(this.collateralBuild.configuration);
                default:
                    break;
            }
        },

        getPortraitWidth() {
            var custom = this.collateralBuild.options.pageSizes[0].key;
            var a4 = this.collateralBuild.options.pageSizes[1].key;
            var letter = this.collateralBuild.options.pageSizes[2].key;
            var paper5x7 = this.collateralBuild.options.pageSizes[3].key;
            var paper4x6 = this.collateralBuild.options.pageSizes[4].key; 

            switch(this.collateralBuild.pageSize)
            {
                case a4:
                    return 2481;
                case letter:
                    return 2550;
                case paper5x7:
                    return 1500;
                case paper4x6:
                    return 1200;
                case custom:
                    return this.generateCustomWidth(this.collateralBuild.configuration);
                default:
                    break;
            }
        },

        getLandscapeWidth() {
            var custom = this.collateralBuild.options.pageSizes[0].key;
            var a4 = this.collateralBuild.options.pageSizes[1].key;
            var letter = this.collateralBuild.options.pageSizes[2].key;
            var paper5x7 = this.collateralBuild.options.pageSizes[3].key;
            var paper4x6 = this.collateralBuild.options.pageSizes[4].key; 

            switch(this.collateralBuild.pageSize)
            {
                case a4:
                    return 3505;
                case letter:
                    return 3300;
                case paper5x7:
                    return 2100;
                case paper4x6:
                    return 1800;
                case custom:
                    // Landscape flips width and height
                    return this.generateCustomHeight(this.collateralBuild.configuration);
                default:
                    break;
            }
        },

        generateCustomWidth(configuration) {
            if (configuration.customSettings) {
                const dimension = configuration.customSettings.customWidth;
                const customUnits = configuration.customSettings.customUnits;
    
                const customWidth = this.generateCustomCanvasSize(dimension, customUnits);
                return customWidth;
            }

            return null;
        },

        generateCustomHeight(configuration) {
            if (configuration.customSettings) {
                const dimension = configuration.customSettings.customHeight;
                const customUnits = configuration.customSettings.customUnits;
    
                const customHeight = this.generateCustomCanvasSize(dimension, customUnits);
                return customHeight;
            }

            return null;
        },

        getPixelConversionMultiplier(customUnits) {
            let dimensionModifier = 1;

            // In EvoPDF, 1 point (pixel) is 1/72 inches
            switch (customUnits.toLowerCase()) {
                case "inches":
                    dimensionModifier = 72;
                    break;
                case "mm":
                    dimensionModifier = 2.835;
                    break;
                case "cm":
                    dimensionModifier = 28.35;
                    break;
                case "px":
                    // Users enter pixels with PDFScaleFactor already applied,
                    // which needs to be undone to match backend processing
                    dimensionModifier = (1 / this.collateralBuild.pdfScaleFactor);
                    break;
                default:
                    break;
            }

            return dimensionModifier;
        },

        generateCustomCanvasSize(dimension, customUnits) {
            // convert from inches, mm, or cm to pixels
            const pixelConversionMultiplier = this.getPixelConversionMultiplier(customUnits);
            const pixels = dimension * pixelConversionMultiplier;

            // ensure pixels don't escape boundaries
            let boundedPixels;
            if (boundedPixels > 100000) {
                boundedPixels = 100000;
            } else if (boundedPixels < 2) {
                boundedPixels = 2;
            } else {
                boundedPixels = pixels;
            }

            // round pixels down prior to scaling, to match rounding performed by backend during PDF creation
            const pixelsFloor  = Math.floor(boundedPixels);

            // scale pixels up for rendering
            const scaledPixels = pixelsFloor * this.collateralBuild.pdfScaleFactor;
            const scaledPixelsFloor = Math.floor(scaledPixels);
            return scaledPixelsFloor;
        },

        processBranding(configuration) {
            configuration.pages.forEach(page => {
                this.processPageBranding(page);
                page.elements.forEach(element => {
                    this.processElementBranding(element);
                });

                if (page.masterPage) {
                    this.processPageBranding(page.masterPage);
                    page.masterPage.elements.forEach(element => {
                        this.processElementBranding(element);
                    });
                }
            });

            configuration.masterPages.forEach(masterPage => {
                this.processPageBranding(masterPage);
                masterPage.elements.forEach(element => {
                    this.processElementBranding(element);
                });
            });
        },

        processPageBranding(page) {
            this.refreshBrandingColor(page.backgroundColor);
        },

        processElementBranding(element) {
            if(element.type.toUpperCase() === 'TEXT') {
                element.body = this.processTextBranding(element.body);
            }
            else if(element.type.toUpperCase() === 'SHAPE') {
                this.processShapeBranding(element);
            }
            else if(element.type.toUpperCase() === 'BUTTON') {
                this.processButtonBranding(element);
            }
            else if(element.type.toUpperCase() === 'PAGINATION') {
                this.processPaginationBranding(element);
            }
        },
        
        processShapeBranding(element) {
            if(!element.color1.locked) {
                this.refreshBrandingColor(element.color1);
            }

            if(!element.color2.locked) {
                this.refreshBrandingColor(element.color2);
            }

            if(!element.color3.locked) {
                this.refreshBrandingColor(element.color3);
            }
        },

        processTextBranding(unprocessedElement) {
            var branding = this.collateralBuild.options.brandingOptions;

            var el = document.createElement('span');
            el.innerHTML = unprocessedElement;
    
            for (var i = 0; i < branding.length; i++) {
                var selector = `[data-branding='${branding[i].key}']`;
                var elements = el.querySelectorAll(selector);
    
                if (elements.length > 0) {
                    for (var j = 0; j < elements.length; j++) {
                        var element = el.querySelectorAll(selector)[j];
                        element.style.color = branding[i].color;
                    }
                }
            }
    
            return el.innerHTML;
        },

        processButtonBranding(unprocessedElement) {
            this.refreshBrandingColor(unprocessedElement.textColor);
            this.refreshBrandingColor(unprocessedElement.buttonColor);
            this.refreshBrandingColor(unprocessedElement.borderColor);
        },

        processPaginationBranding(unprocessedElement) {
            this.refreshBrandingColor(unprocessedElement.color);
        },

        refreshBrandingColor(color) {
            if(color.type && color.type.toUpperCase() === 'BRANDED') {
                var branding = this.collateralBuild.options.brandingOptions.find(brandingOption => brandingOption.key === color.branding);
                color.value = branding.color;
            }
        },

        addElement(element, pageId) {
            pageId = pageId || this.getSelectedPageFromContext().id;
            element.pageId = pageId;
            
            var page = this.getPageById(pageId);

            page.elements.unshift(element);
            this.initializeElementProperties(element, page);
            this.initializeElementBranding(element)
        },

        initializeElementProperties(element, page) {
            this.setElementsZPosition(page);

            if(element.type === 'pagination') {
                this.setPaginationNumeral(null, element);
            }
        },
        
        setElementsZPosition(page) {
            page.elements.forEach((element, index) => {
                element.position.z = page.elements.length - index;
            });
        },

        initializeElementBranding(element) {
            if(element.type === 'pagination') {
                this.setPaginationElementBranding(element);
            }

            if(element.type === 'company-logo') {
                if (this.collateralBuild.account.clientId) {
                    element.src = this.collateralBuild.configuration.global.image.src;
                    element.name = this.collateralBuild.configuration.global.image.name;
                }
                else {
                    element.src = this.collateralBuild.agencyPlaceholderLogoUrl;
                    element.name = 'Placeholder';
                }
            }
        },

        setPaginationIndex(pageIndex, element) {
            this.setPaginationNumeral(pageIndex, element);
            this.updatePaginationDimensions(element);
        },

        setPaginationNumeral(pageIndex, element) {
            if(!pageIndex) {
                var pages = this.getPagesFromContext();
                pages.forEach((page, index) => {
                    if(page.id === element.pageId) {
                        pageIndex = index;
                    }
                });
            }

            element.index = pageIndex + 1;
            element.displayIndex = this.getNumeral(element.index, element.enumeration.value);
        },

        getNumeral(index, convertToType) {
            if(convertToType.toUpperCase() === 'LABELEDARABICNUMERALS')
            {
                return `Page ${index}`;
            }
            else if(convertToType.toUpperCase() === 'LOWERCASEROMANNUMERALS') {
                return this.getRomanNumerals(index).toLowerCase();
            }
            else if(convertToType.toUpperCase() === 'UPPERCASEROMANNUMERALS') {
                return this.getRomanNumerals(index).toUpperCase();
            }
            else {
                return index.toString();
            }
        },

        getRomanNumerals(arabicNumer) {
            var lookup = {M:1000,CM:900,D:500,CD:400,C:100,XC:90,L:50,XL:40,X:10,IX:9,V:5,IV:4,I:1};
            var roman = '';
            var i;

            for (i in lookup) {
                while ( arabicNumer >= lookup[i] ) {
                    roman += i;
                    arabicNumer -= lookup[i];
                }
            }

            return roman;
        },

        setPaginationElementBranding(element) {
            element.color = cloneDeep(this.collateralBuild.configuration.global.pagination.color);
            element.fontFamily = cloneDeep(this.collateralBuild.configuration.global.pagination.fontFamily);
            element.fontSize = this.collateralBuild.configuration.global.pagination.fontSize;
        },

        updatePaginationDimensions(element) {
            element.dimensions.width = 'auto';
            element.dimensions.height = 'auto';

            this.$nextTick(() => {
                this.updateBoundingBox(element);
                this.updateRotationCoordinates(element);

                element.dimensions.width = element.boundingBox.width;
                element.dimensions.height = element.boundingBox.height;

                element.innerDimensions.width = element.boundingBox.width;
                element.innerDimensions.height = element.boundingBox.height;
            });
        },

        getElementControlZPosition(element) {
            return this.getPageById(element.pageId).elements.length + 1;
        },

        doesElementExist(element) {
            var selectedPage = this.getSelectedPageFromContext();
            return selectedPage && selectedPage.elements.some(el => el.id === element.id);
        },

        calculateAlignment(element, value) {
            switch(value.toUpperCase()) {
                case 'LEFT':
                    var correction = (element.boundingBox.width - element.dimensions.width) / 2;
                    element.position.x = correction;
                    break;
                case 'CENTER':
                    element.position.x = (this.getPageWidth() - element.boundingBox.width) / 2;
                    break;
                case 'RIGHT':
                    var correction = (element.boundingBox.width - element.dimensions.width) / 2;
                    element.position.x = this.getPageWidth() - element.boundingBox.width + correction;
                    break;
                case 'TOP':
                    var correction = (element.boundingBox.height - element.dimensions.height) / 2;
                    element.position.y = correction;
                    break;
                case 'MIDDLE':
                    element.position.y = (this.getPageHeight() - element.boundingBox.height) / 2;
                    break;
                case 'BOTTOM':
                    var correction = (element.boundingBox.height - element.dimensions.height) / 2;
                    element.position.y = this.getPageHeight() - element.boundingBox.height + correction;
                    break;
                default:
                    break;
            }
        },

        getRotationCursorDegrees(element) {
            var degrees = this.getNormalizedDegrees(element.rotate) + 15;

            return ~~(degrees / 30) * 30;
        },

        getNormalizedDegrees(degrees) {
            while(degrees < 0) { degrees += 360; }
            while(degrees > 360) { degrees -= 360; } 

            return degrees;
        },

        getCursorToleranceAdjustment(relativeDegrees, roundedDegrees) {
            var multipleOf90 = roundedDegrees % 90 === 0;

            if(multipleOf90) {
                var isLowerRange = relativeDegrees > (roundedDegrees - this.collateralBuild.degreeSegmentation)
                    && relativeDegrees < roundedDegrees;

                if(isLowerRange) {
                    return roundedDegrees - this.collateralBuild.degreeSegmentation;
                }

                var isUpperRange = relativeDegrees > roundedDegrees
                    && relativeDegrees < (roundedDegrees + this.collateralBuild.degreeSegmentation);

                if(isUpperRange) {
                    return roundedDegrees + this.collateralBuild.degreeSegmentation;
                }                    
            }
            else {
                return roundedDegrees;
            }
        },
        
        zoomIn() {
            var updatedZoom = this.collateralBuild.zoom + this.collateralBuild.zoomIncrement;

            if (updatedZoom > this.collateralBuild.maxZoom) {
                updatedZoom = this.collateralBuild.maxZoom;
            }

            this.collateralBuild.zoom = updatedZoom;
        },

        zoomOut() {
            var updatedZoom = this.collateralBuild.zoom - this.collateralBuild.zoomIncrement;

            if (updatedZoom < this.collateralBuild.minZoom) {
                updatedZoom = this.collateralBuild.minZoom;
            }

            this.collateralBuild.zoom = updatedZoom;
        },

        getScaleCursorDegrees(element) {
            var rads = Math.atan((element.dimensions.height) / (element.dimensions.width));
            var referenceAngle = rads * 180 / Math.PI;

            var degrees = element.rotate;

            if(element.scaleOrigin.toUpperCase() === 'TOPLEFT' || element.scaleOrigin.toUpperCase() === 'BOTTOMRIGHT') {
                degrees += referenceAngle;
    
            }
            else {
                degrees -= referenceAngle;
            }
            
            degrees = this.getNormalizedDegrees(degrees);
            var roundedDegrees = ~~(degrees /  this.collateralBuild.degreeSegmentation) *  this.collateralBuild.degreeSegmentation;

            degrees = this.getCursorToleranceAdjustment(degrees, roundedDegrees);

            return degrees;
        },

        getCroppingDegrees(element) {
            if(!element.cropType) { return 0 }

            var degrees;

            if(element.cropType.toUpperCase() === 'WIDTH') {
                degrees = this.getNormalizedDegrees(element.rotate) + this.collateralBuild.degreeSegmentation / 2;
            }
            else {
                degrees = element.rotate - 90;
                degrees = this.getNormalizedDegrees(degrees) + this.collateralBuild.degreeSegmentation / 2;
            }

            return ~~(degrees / this.collateralBuild.degreeSegmentation) * this.collateralBuild.degreeSegmentation;
        },

        getFontSizes() {
            return ["8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "22", "24", "26", "28", "30", "32", "34", "36", "40", "44", "48", "52", "56", "64"]
        },

        getLineHeights() {
            return ["4", "5", "6", "7", ...this.getFontSizes()];
        },

        generateFroalaFontSizeOptions() {
            var options = {};
            var fontSizes = this.getFontSizes();

            for(var i = 0; i < fontSizes.length; i++) {
                options[fontSizes[i]] = fontSizes[i];
            }

            return options;
        },

        /* Page Navigation Controls */
        startPan(event) {
            if (this.collateralBuild.cursor === 'pan') {
                this.collateralBuild.isPanning = true;
                this.collateralBuild.lastPanCoordinates.x = event.clientX;
                this.collateralBuild.lastPanCoordinates.y = event.clientY;
            }
        },

        pan(event) {
            if (this.collateralBuild.cursor === 'pan' && this.collateralBuild.isPanning) {
                var canvas = document.getElementById('collateral-canvas');

                canvas.scrollLeft += this.collateralBuild.lastPanCoordinates.x - event.clientX;
                canvas.scrollTop += this.collateralBuild.lastPanCoordinates.y - event.clientY;
                
                this.collateralBuild.lastPanCoordinates.x = event.clientX;
                this.collateralBuild.lastPanCoordinates.y = event.clientY;
            }
        },

        endPan() {
            this.collateralBuild.isPanning = false;
        },

        /* Element Transforms */

        /* Drag */
        startDrag(event) {
            event.preventDefault();

            this.selectedElements.forEach(element => {
                if (!element.isScaling && !element.isRotating) {
                    element.isStretching = false;
                    element.isScaling = false;
                    element.isClicked = true;
                    this.collateralBuild.isTransforming = true;
                    this.setMouseCoordinates(element, event.clientX, event.clientY);
                    document.onmouseup = () => this.endDrag();

                    document.onmousemove = () => this.dragElement(null);
                }
            })

        },

        dragElement(event) {
            this.selectedElements.forEach(element => {
                if(element.isDragging || element.isClicked) {
                    event = event || window.event;
                    event.preventDefault();

                    if(!element.isDragging) {
                        if(this.metDragTolerance(event, element)) {
                            element.isDragging = true;
                        }
                    }
                    else {
                        var mouseDeltaCoordinates = this.getMouseDeltaCoordinates(element, event.clientX, event.clientY);
        
                        element.position.x = Math.round(element.position.x + mouseDeltaCoordinates.deltaX);
                        element.position.y = Math.round(element.position.y + mouseDeltaCoordinates.deltaY);
        
                        this.setMouseCoordinates(element, event.clientX, event.clientY);
                    }
                }
            });
        },

        metDragTolerance(event, element) {
            var mouseXDistance = Math.abs(element.mouseX - event.clientX);
            var mouseYDistance = Math.abs(element.mouseY - event.clientY);

            return mouseXDistance > element.dragTolerance
                || mouseYDistance > element.dragTolerance;
        },

        adjustDragForScroll(difference, element) {
            var change = difference * (1 / this.getScaleFactor());

            element.position.y -= change;
        },

        endDrag() {
            this.selectedElements.forEach(element => {
                element.isDragging = false;
                element.isClicked = false;
                element.isRotating = false;
                element.isScaling = false;
                element.isStretching = false;

                if(element.type === 'text') {
                    element.editMode = true;
                }

                this.setMouseCoordinates(element, null, null);
                this.resetMouseUpEvent();
                this.updateBoundingBox(element);
                this.updateRotationCoordinates(element);
                this.setElementDestination(element);

                if (element.type === 'pagination') {
                    this.setPaginationIndex(null, element);
                }
            });
        },

        setElementDestination(element) {
            var pageHeight = this.getPageHeight();

            var elementHeightCorrection = element.boundingBox.height - element.dimensions.height;
            var correctedElementPositionY = element.position.y - elementHeightCorrection / 2;

            var hasTraveledSouth = correctedElementPositionY > pageHeight;
            var hasTraveledNorth = correctedElementPositionY + element.boundingBox.height < 0;

            if(hasTraveledSouth || hasTraveledNorth) {
                this.setElementsNewPage(element, pageHeight, correctedElementPositionY, hasTraveledSouth);
            }
        },

        getPageMetaByElement(element) {
            var pageMetas = [];
            var pages = this.getPagesFromContext();

            pages.forEach((page, index) => {
                if(page.id === element.pageId) {
                    pageMetas.push({
                        page: page,
                        index: index
                    })
                }
            });

            return pageMetas[0];
        },

        getBlocksTraveled(element, correctedElementPositionY, blockHeight) {
            var blocksTraveled = 0;
            var travelingSouth = element.position.y > 0;

            if(travelingSouth) {
                var blocksTraveled = ~~(correctedElementPositionY / blockHeight);
            }
            else {
                blocksTraveled = Math.abs(~~((correctedElementPositionY + element.boundingBox.height) / blockHeight));
            }

            return blocksTraveled;
        },

        setElementsNewPage(element, pageHeight, correctedElementPositionY, hasTraveledSouth) {
            var newPageIndex = null;

            var pageMeta = this.getPageMetaByElement(element);
            var startingPage = pageMeta.page;
            var startingIndex = pageMeta.index;
            
            var pageMargin = pageHeight * this.collateralBuild.pageMarginFactor;
            var blockHeight = pageHeight + pageMargin;
            var blocksTraveled = this.getBlocksTraveled(element, correctedElementPositionY, blockHeight);

            if(hasTraveledSouth) {
                    var delta = correctedElementPositionY - blockHeight * blocksTraveled;
                    if(delta > pageHeight) {
                        newPageIndex = startingIndex + blocksTraveled + 1;
                        element.position.y = element.position.y - (blocksTraveled + 1) * blockHeight;
                    }
                    else {
                        newPageIndex = startingIndex + blocksTraveled;
                        element.position.y = element.position.y % (blockHeight * blocksTraveled);
                    }
            }
            else {
                var delta = Math.abs(correctedElementPositionY) - blockHeight * blocksTraveled;

                newPageIndex = startingIndex - (blocksTraveled + 1);
                element.position.y = blockHeight - delta;
            }

            var pages = this.getPagesFromContext();

            if(newPageIndex < 0) {newPageIndex = 0}
            if(newPageIndex > pages.length -1) {newPageIndex = pages.length -1}

            this.removeElementByPage(startingPage, element);
            var destinationPage = pages[newPageIndex];
            element.pageId = destinationPage.id;
            destinationPage.elements.push(element);

            this.selectPage(destinationPage);
            this.setSettingsContext(element.type, element);
        },

        removeElementByPage(page, element) {
            page.elements.forEach(el => {
                if(element.id === el.id) {
                    page.elements.splice(page.elements.indexOf(element), 1);
                }
            });
        },

        getMouseDeltaCoordinates(element, mouseX, mouseY) {
            return {
                deltaX: this.getInverseScaleFactor() * (mouseX - element.mouseX),
                deltaY: this.getInverseScaleFactor() * (mouseY - element.mouseY) 
            };
        },

        /* Scale */
        startScale(event, element, direction, origin) {
            event.preventDefault();

            element.scaleDirection = direction;
            element.scaleOrigin = origin;
            element.isDragging = false;
            element.isClicked = false;
            element.isStretching = false;
            element.isScaling = true;
            this.collateralBuild.isTransforming = true;
            this.setMouseCoordinates(element, event.clientX, event.clientY);

            document.onmousemove = () => this.scaleElement(null, element);
            document.onmouseup = () => this.endScale(element);
        },

        scaleElement(event, element) {
            if (element.isScaling) {
                event = event || window.event;
                event.preventDefault();

                var deltaMouse = this.getMouseDeltaCoordinates(element, event.clientX, event.clientY);
                var widthDelta, heightDelta;

                if (element.keepAspectRatio) {
                    var widthDelta = this.getWidthDelta(element, deltaMouse.deltaX, deltaMouse.deltaY);
                    var newWidth = element.dimensions.width - widthDelta;

                    var ratio = newWidth / element.dimensions.width;

                    heightDelta = element.dimensions.height - element.dimensions.height * ratio;
                }
                else {
                    element.dimensions.width -= deltaMouse.deltaX;
                    element.dimensions.height -= deltaMouse.deltaY;
                }
                
                var proposedWidth = element.dimensions.width + widthDelta;
                var propsedHeight = element.dimensions.height + heightDelta;
                
                var shouldUpdateDimensions = proposedWidth > 20 && propsedHeight > 20;
                
                if (shouldUpdateDimensions) {
                    element.dimensions.width += widthDelta;
                    element.dimensions.height += heightDelta;

                    if (element.dimensions.width < element.innerDimensions.width) {
                        var imageWidthDelta = (element.innerDimensions.width * widthDelta) / element.dimensions.width;

                        this.adjustByHorizontalChange(element, imageWidthDelta);
                        this.adjustOffsetByDimensionDeltas(element, widthDelta, heightDelta);

                    }

                    this.calculatePositionCorrection(element, widthDelta, heightDelta);
                    this.syncInnerDimensions(element);
                }

                this.setMouseCoordinates(element, event.clientX, event.clientY);
            }
        },

        endScale(element) {
            element.isScaling = false;
            element.scaleDirection = null;

            this.setMouseCoordinates(element, null, null);
            this.resetMouseUpEvent();
            this.resetMouseMouseMoveEvent();
            this.updateBoundingBox(element);
            this.updateRotationCoordinates(element);
        },

        calculatePositionCorrection(element, widthDelta, heightDelta) {
            if(element.scaleOrigin.toUpperCase() === 'TOPLEFT') {
                element.position.x = element.position.x - widthDelta;
                element.position.y = element.position.y - heightDelta;
            }

            if(element.scaleOrigin.toUpperCase() === 'TOPRIGHT') {
                element.position.x = element.position.x;
                element.position.y = element.position.y - heightDelta;
            }

            if(element.scaleOrigin.toUpperCase() === 'BOTTOMLEFT') {
                element.position.x = element.position.x - widthDelta;
                element.position.y = element.position.y;
            }
        },

        adjustOffsetByDimensionDeltas(element, widthDelta, heightDelta) {
            element.offset.x += (element.offset.x / element.dimensions.width) * widthDelta;
            element.offset.y += (element.offset.y / element.dimensions.height) * heightDelta; 
        },

        /* Rotate */
        startRotate(event, element) {
            event.preventDefault();
            element.isScaling = false;
            element.isDragging = false;
            element.isClicked = false;
            element.isStretching = false;
            element.isRotating = true;
            this.collateralBuild.isTransforming = true;

            this.updateRotationCoordinates(element);
            this.setStartAngle(event, element);
            this.setDegreesDisplay(event, element);

            document.onmousemove = () => this.rotateElement(null, element);
            document.onmouseup = () => this.endRotate(element);
        },

        rotateElement(event, element) {
            if(element.isRotating) {
                event = event || window.event;
                event.preventDefault();

                var angle = this.getAngle(event, element);
                element.rotate = angle - element.startingAngle;

                this.setDegreesDisplay(event, element);
            }
        },

        setStartAngle(event, element) {
            element.startingAngle = this.getAngle(event, element) - element.rotate;
        },

        getAngle(event, element) {
            var radians =  Math.atan2(element.rotateCoordinates.y - event.clientY, element.rotateCoordinates.x - event.clientX);
            return radians * 180 / Math.PI;
        },

        setDegreesDisplay(event, element) {
            element.degreesDisplayCoordinates.x = event.clientX;
            element.degreesDisplayCoordinates.y = event.clientY;
        },

        endRotate(element) {
            element.isRotating = false;

            this.setMouseCoordinates(element, null, null);
            this.resetMouseUpEvent();
            this.resetMouseMouseMoveEvent();
            this.updateBoundingBox(element);
            this.updateRotationCoordinates(element);
        },

        /* Crop */
        startCrop(event, element, direction, type, origin) {
            event.preventDefault();

            element.cropType = type;
            element.scaleOrigin = origin;
            element.scaleDirection = direction;
            element.isDragging = false;
            element.isClicked = false;
            element.isScaling = false;
            element.isRotating = false;
            element.isStretching = true;
            this.collateralBuild.isTransforming = true;

            this.setMouseCoordinates(element, event.clientX, event.clientY);

            document.onmousemove = () => this.cropElement(null, element);
            document.onmouseup = () => this.endCrop(element);
        },

        cropElement(event, element) {
           if(element.isStretching) {
                event = event || window.event;
                event.preventDefault();

                var deltaMouse = this.getMouseDeltaCoordinates(element, event.clientX, event.clientY);

                if(element.cropType.toUpperCase() === 'WIDTH') {
                    this.cropElementWidth(element, deltaMouse.deltaX, deltaMouse.deltaY);
                }
                else {
                    this.cropElementHeight(element, deltaMouse.deltaX, deltaMouse.deltaY);
                }
                        
                this.setMouseCoordinates(element, event.clientX, event.clientY);
           }
        },

        cropElementHeight(element, deltaX, deltaY) {
            var widthDelta = 0;

            var heightDelta = this.getHeightDelta(element, deltaX, deltaY);
            var proposedHeight = element.dimensions.height + heightDelta;

            var shouldUpdateDimensions = proposedHeight > 0;
            if(shouldUpdateDimensions) {
                element.dimensions.height = proposedHeight;

                this.calculateCropAdjustments(element, widthDelta, heightDelta);

                if(element.cropable) {
                    this.syncInnerDimensions(element);
                }
                else {
                    element.offset.y = 0;
                    element.innerDimensions.height = element.dimensions.height;
                }
            } 
        },

        cropElementWidth(element, deltaX, deltaY) {
            var heightDelta = 0;

            var widthDelta = this.getWidthDelta(element, deltaX, deltaY);
            var proposedWidth = element.dimensions.width + widthDelta;

            var shouldUpdateDimensions = proposedWidth > 0;
            if (shouldUpdateDimensions) {
                element.dimensions.width = proposedWidth;

                this.calculateCropAdjustments(element, widthDelta, heightDelta);

                if (element.cropable) {
                    this.syncInnerDimensions(element);
                }
                else {
                    element.offset.x = 0;
                    element.innerDimensions.width = element.dimensions.width;
                }
            }
        },

        getWidthDelta(element, deltaX, deltaY) {
            var elementAngleInRadians = this.degreesToRadians(element.rotate);
            var deltaAngleInRadians = this.getRadiansByCoordinates(deltaX, deltaY);
            var adjustedAngleInRadians = deltaAngleInRadians - elementAngleInRadians;
            var adjustedAngleInDegrees = this.radiansToDegrees(adjustedAngleInRadians);
            adjustedAngleInDegrees = this.adjustDegreesToBePositive(adjustedAngleInDegrees);

            var angledScaleX = Math.cos(elementAngleInRadians);
            var angledScaleY = Math.sin(elementAngleInRadians);
            var scaledDeltaX = deltaX * angledScaleX;
            var scaledDeltaY = deltaY * angledScaleY;
            
            return element.scaleDirection * this.getHorizontalSignByDegrees(adjustedAngleInDegrees) * this.getHypotenuse(scaledDeltaX, scaledDeltaY);
        },

        getHeightDelta(element, deltaX, deltaY) {
            var elementAngleInRadians = this.degreesToRadians(element.rotate);
            var deltaAngleInRadians = this.getRadiansByCoordinates(deltaX, deltaY);
            var adjustedAngleInRadians = deltaAngleInRadians - elementAngleInRadians;
            var adjustedAngleInDegrees = this.radiansToDegrees(adjustedAngleInRadians);
            adjustedAngleInDegrees = this.adjustDegreesToBePositive(adjustedAngleInDegrees);

            var angledScaleX = Math.sin(elementAngleInRadians);
            var angledScaleY = Math.cos(elementAngleInRadians);
            var scaledDeltaX = deltaX * angledScaleX;
            var scaledDeltaY = deltaY * angledScaleY;
            
            return element.scaleDirection * this.getVerticalSignByDegrees(adjustedAngleInDegrees) * this.getHypotenuse(scaledDeltaX, scaledDeltaY);
        },

        getRadiansByCoordinates(x, y) {
            var angleInRadians = Math.atan(y / x);
            angleInRadians = this.adjustAngleForQuadrant(angleInRadians, x, y);

            return angleInRadians;
        },

        adjustAngleForQuadrant(radians, x, y) {
            if (x < 0) {
                radians += Math.PI;
            }

            return radians;
        },

        getHypotenuse(x, y) {
            return Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2))
        },

        getVerticalSignByDegrees(degrees) {
            if (degrees > 0 && degrees < 180) {
                return 1;
            }
            else {
                return -1;
            }
        },

        getHorizontalSignByDegrees(degrees) {
            if (degrees > 90 && degrees < 270) {
                return -1;
            }
            else {
                return 1;
            }
        },

        adjustDegreesToBePositive(degrees) {
            while (degrees < 0) {
                degrees += 360;
            }

            return degrees;
        },

        radiansToDegrees(radians) {
            return radians * (180 / Math.PI);
        },

        degreesToRadians(degrees) {
            return degrees * (Math.PI / 180);
        },

        endCrop(element) {
            element.isStretching = false;
            element.cropType = null;

            this.setMouseCoordinates(element, null, null);
            this.resetMouseUpEvent();
            this.resetMouseMouseMoveEvent();
            this.updateBoundingBox(element);
            this.updateRotationCoordinates(element);
        },

        calculateCropAdjustments(element, widthDelta, heightDelta) {
            if(element.scaleOrigin.toUpperCase() === 'LEFT') {
                this.calculateCropAdjustmentsFromLeft(element, widthDelta, heightDelta);
            }
            else if (element.scaleOrigin.toUpperCase() === 'RIGHT') {
                this.calculateCropAdjustmentsFromRight(element, widthDelta, heightDelta);
            }
            else if (element.scaleOrigin.toUpperCase() === 'TOP') {
                this.calculateCropAdjustmentsFromTop(element, widthDelta, heightDelta);
            }
            else if(element.scaleOrigin.toUpperCase() === 'BOTTOM') {
                this.calculateCropAdjustmentsFromBottom(element, widthDelta, heightDelta);
            }
        },

        calculateCropAdjustmentsFromBottom(element, widthDelta, heightDelta) {
            var elementAngleInRadians = this.degreesToRadians(element.rotate);
            var xPositionCorrection = heightDelta * Math.sin(elementAngleInRadians) / 2;
            var yPositionCorrection = (heightDelta - heightDelta * Math.cos(elementAngleInRadians)) / 2;
            
            element.position.x = element.position.x - xPositionCorrection;
            element.position.y = element.position.y - yPositionCorrection;

            if (element.dimensions.height < element.innerDimensions.height) {
                if (element.dimensions.height - element.offset.y > element.innerDimensions.height && element.cropable) {
                    if (heightDelta > 0) {
                        this.adjustByVerticalChange(element, heightDelta);
                    }
                }
            }
        },

        calculateCropAdjustmentsFromTop(element, widthDelta, heightDelta) {
            var elementAngleInRadians = this.degreesToRadians(element.rotate);
            var xPositionCorrection = (widthDelta - heightDelta * Math.sin(elementAngleInRadians)) / 2;
            var yPositionCorrection = (heightDelta + heightDelta * Math.cos(elementAngleInRadians)) / 2;
            
            element.position.x = element.position.x - xPositionCorrection;
            element.position.y = element.position.y - yPositionCorrection;

            if (element.dimensions.height < element.innerDimensions.height) {
                element.offset.y += heightDelta;
                if (heightDelta > 0 && element.offset.y > 0  && element.cropable) {
                    this.adjustByVerticalChange(element, heightDelta);
                    element.offset.y = 0;
                }
            }
            else {
                element.offset.y = 0;
            }
        },

        calculateCropAdjustmentsFromLeft(element, widthDelta, heightDelta) {
            var elementAngleInRadians = this.degreesToRadians(element.rotate);
            
            var xPositionCorrection = (widthDelta + widthDelta * Math.cos(elementAngleInRadians)) / 2;
            var yPositionCorrection = widthDelta * Math.sin(elementAngleInRadians) / 2;

            element.position.x = element.position.x - xPositionCorrection;
            element.position.y = element.position.y - yPositionCorrection;

            if(element.dimensions.width < element.innerDimensions.width) {
                var offsetIsAboutZero = (element.offset.x > -1 && element.offset.x < 0) || (element.offset.x == 0) || (element.offset.x > 0 && element.offset.x < 1);

                if(widthDelta > 0 && offsetIsAboutZero && element.cropable) {
                    this.adjustByHorizontalChange(element, widthDelta);
                }
                else {
                    element.offset.x += widthDelta;
                }
            }
            else {
                element.offset.x = 0;
            }
        },

        calculateCropAdjustmentsFromRight(element, widthDelta, heightDelta) {
            var elementAngleInRadians = this.degreesToRadians(element.rotate);
            var xPositionCorrection = (widthDelta - widthDelta * Math.cos(elementAngleInRadians)) / 2;
            var yPositionCorrection = (heightDelta - widthDelta * Math.sin(elementAngleInRadians)) / 2;
            
            element.position.x = element.position.x - xPositionCorrection;
            element.position.y = element.position.y - yPositionCorrection;

            if (element.dimensions.width < element.innerDimensions.width) {
                if(element.dimensions.width - element.offset.x > element.innerDimensions.width  && element.cropable) {
                    this.adjustByHorizontalChange(element, widthDelta);
                }
            }
            else {
                element.offset.x = 0;
            }
        },

        adjustByHorizontalChange(element, widthDelta) {
            var heightChange = (element.innerDimensions.height / element.innerDimensions.width) * widthDelta;
            element.innerDimensions.width += widthDelta;
            element.innerDimensions.height += heightChange;
        },

        adjustByVerticalChange(element, heightDelta) {
            var widthChange = (element.innerDimensions.width / element.innerDimensions.height) * heightDelta; 
            element.innerDimensions.width += widthChange;
            element.innerDimensions.height += heightDelta;
        },

        syncInnerDimensions(element) {
            if(element.dimensions.width > element.innerDimensions.width) {
                var ratio = (element.dimensions.width - element.innerDimensions.width) / element.innerDimensions.width;
                element.innerDimensions.width = element.dimensions.width;
                element.innerDimensions.height = element.innerDimensions.height + element.innerDimensions.height * ratio;
            }

            if(element.dimensions.height > element.innerDimensions.height) {
                element.innerDimensions.width = (element.innerDimensions.width / element.innerDimensions.height) * element.dimensions.height;
                element.innerDimensions.height = element.dimensions.height;
            } 
        },

        setMouseCoordinates(element, x, y) {
            element.mouseX = x;
            element.mouseY = y;
        },

        getScaleFactor() {
            return this.collateralBuild.zoom / 100;
        },

        getInverseScaleFactor() {
            return 1 / this.getScaleFactor();
        },

        resetMouseUpEvent() {
            document.onmouseup = null;
        },

        resetMouseMouseMoveEvent() {
            document.onmousemove = null;
        },

        updateRotationCoordinates(element) {
            EventBus.$emit(`update:collateral-element-${ element.id }-rotate-coordinates`);
        },

        updateBoundingBox(element) {
            EventBus.$emit(`update:collateral-element-${ element.id }-bounding-box`);
        },

        flipElement(element, direction) {
            if(direction.toUpperCase() === 'HORIZONTAL') {
                element.flip.x *= -1;
            }
            else {
                element.flip.y *= -1;
            }
        },

        resetContextTransformStates() {
            this.selectedElements.forEach(element=>{
                element.isDragging = false;
                element.isClicked = false;
                element.isScaling = false;
                element.isRotating = false;
                element.isStretching = false;
            })

        },

        insertShortcode(context, cmd, val) {
            var result = { status: 'failed', message: '' };

            if (val === 'companyName') {
                if (this.collateralBuild.account.clientId) {
                    if (this.collateralBuild.options.companyDetails.name) {
                        context.html.insert(this.collateralBuild.options.companyDetails.name);
                        result.status = 'success';
                    }
                    else {
                        result.message = 'No company name found. See branding customization to update settings.';
                    }
                }
                else {
                    context.html.insert('[CompanyName]');
                    result.status = 'success';
                }
            }

            if (val === 'companyAddress') {
                if (this.collateralBuild.account.clientId) {
                    if (this.collateralBuild.options.companyDetails.address) {
                        context.html.insert(this.collateralBuild.options.companyDetails.address);
                        result.status = 'success';
                    }
                    else {
                        result.message = 'No company address found. See branding customization to update settings.';
                    }
                }
                else {
                    context.html.insert('[CompanyAddress]');
                    result.status = 'success';
                }
            }

            if (val === 'companyCity') {
                if (this.collateralBuild.account.clientId) {
                    if (this.collateralBuild.options.companyDetails.city) {
                        context.html.insert(this.collateralBuild.options.companyDetails.city);
                        result.status = 'success';
                    }
                    else {
                        result.message = 'No company city found. See branding customization to update settings.';
                    }
                }
                else {
                    context.html.insert('[CompanyCity]');
                    result.status = 'success';
                }
            }

            if (val === 'companyState') {
                if (this.collateralBuild.account.clientId) {
                    if (this.collateralBuild.options.companyDetails.state) {
                        context.html.insert(this.collateralBuild.options.companyDetails.state);
                        result.status = 'success';
                    }
                    else {
                        result.message = 'No company state found. See branding customization to update settings.';
                    }
                }
                else {
                    context.html.insert('[CompanyState]');
                    result.status = 'success';
                }
            }

            if (val === 'companyZipcode') {
                if (this.collateralBuild.account.clientId) {
                    if (this.collateralBuild.options.companyDetails.zipcode) {
                        context.html.insert(this.collateralBuild.options.companyDetails.zipcode);
                        result.status = 'success';
                    }
                    else {
                        result.message = 'No company zipcode found. See branding customization to update settings.';
                    }
                }
                else {
                    context.html.insert('[CompanyZipcode]');
                    result.status = 'success';
                }
            }

            if (val === 'companyWebsite') {
                if (this.collateralBuild.account.clientId) {
                    if (this.collateralBuild.options.companyDetails.website) {
                        context.html.insert(this.collateralBuild.options.companyDetails.website);
                        result.status = 'success';
                    }
                    else {
                        result.message = 'No company website found. See branding customization to update settings.';
                    }
                }
                else {
                    context.html.insert('[CompanyWebsite]');
                    result.status = 'success';
                }
            }

            if (val === 'companyEmail') {
                if (this.collateralBuild.account.clientId) {
                    if (this.collateralBuild.options.companyDetails.email) {
                        context.html.insert(this.collateralBuild.options.companyDetails.email);
                        result.status = 'success';
                    }
                    else {
                        result.message = 'No company email found. See branding customization to update settings.';
                    }
                }
                else {
                    context.html.insert('[CompanyEmail]');
                    result.status = 'success';
                }
            }

            if (val === 'companyPhone') {
                if (this.collateralBuild.account.clientId) {
                    if (this.collateralBuild.options.companyDetails.phone) {
                        context.html.insert(this.collateralBuild.options.companyDetails.phone);
                        result.status = 'success';
                    }
                    else {
                        result.message = 'No company phone found. See branding customization to update settings.';
                    }
                }
                else {
                    context.html.insert('[CompanyPhone]');
                    result.status = 'success';
                }
            }

            return result;
        },

        initiateKeyDown(event, collateralBuild) {
            var keys = [...collateralBuild.versioning.keys, ...collateralBuild.nudge.keys];
            this.setKey(event.keyCode, keys, true);

            this.initiateUndoRedo(event, collateralBuild);
            var focusedTextElement = collateralBuild.settings.context
                && collateralBuild.settings.context.isFocused;
            
            if (!focusedTextElement) {
                this.initiateNudge(event, collateralBuild);
            }
        },

        initiateKeyUp(event, collateralBuild) {
            var keys = [...collateralBuild.versioning.keys, ...collateralBuild.nudge.keys];
            this.setKey(event.keyCode, keys, false);
            
            if(event.keyCode === 91) {
                keys.forEach(key => { key.active = false });
            }
        },
        
        setKey(keyCode, keys, value) {
            var activeKeys = keys.filter(key => key.keyCode === keyCode);

            if (activeKeys.length) {
                activeKeys.forEach(activeKey => activeKey.active = value);
            }
        },

        initiateNudge(event, collateralBuild) {
            var element = collateralBuild.settings.context;
            if (element && element.id) {
                event.preventDefault();

                this.nudge(collateralBuild.nudge);
            }
        },

        nudge(nudge) {
            var leftKey = nudge.keys.find(key => key.name === 'left' && key.active);
            var upKey = nudge.keys.find(key => key.name === 'up' && key.active);
            var rightKey = nudge.keys.find(key => key.name === 'right' && key.active);
            var downKey = nudge.keys.find(key => key.name === 'down' && key.active);
            var shiftKey = nudge.keys.find(key => key.name === 'shift' && key.active);

            var moveHorizontal = shiftKey ? nudge.superHorizontal : nudge.horizontal;
            var moveVertical = shiftKey ? nudge.superVertical : nudge.vertical;


            this.selectedElements.forEach(element=>{
                if (leftKey) {
                    element.position.x += -1 * moveHorizontal;
                }
    
                if (rightKey) {
                    element.position.x += moveHorizontal;
                }
    
                if (upKey) {
                    element.position.y += -1 * moveVertical;
                }
    
                if (downKey) {
                    element.position.y += moveVertical;
                }
            })

        },

        getFormattedPageSize(pageSize = '') {
            if (!pageSize) {
                return '';
            }
            else if (pageSize.toUpperCase() === 'PAPER5X7') {
                return 'Paper 5x7'
            }
            else if (pageSize.toUpperCase() === 'PAPER4X6') {
                return 'Paper 4x6'
            }
            else {
                return pageSize;
            }
        }
    }
};